import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import TextInput from "../../../../common/components/TextInput";

const FEEDBACK_MAX_LENGTH = 100;

const NegativeFeedbackModal = ({ show, onCancel, onSubmit }) => {
  const [feedbackText, setFeedbackText] = useState("");

  useEffect(() => {
    setFeedbackText("");
  }, [show]);

  /**
   * @param {SyntheticEvent} event
   */
  const onFeedbackTextChange = (event) => {
    setFeedbackText(event.currentTarget.value);
  };

  const _onSubmit = () => {
    if (feedbackText.length <= FEEDBACK_MAX_LENGTH) {
      onSubmit({ feedbackText });
    }
  };

  return (
    <Modal
      className="gen-answer-feedback-modal"
      show={show}
      onHide={onCancel}
      backdrop
      keyboard
    >
      <Modal.Header className="has-border">
        <Modal.Title as="h4">Help us improve</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextInput
          textArea
          name="gen-answer-feedback-text"
          label="Provide additional feedback (Optional)"
          onChange={onFeedbackTextChange}
          value={feedbackText}
          error={
            feedbackText.length > FEEDBACK_MAX_LENGTH
              ? `Max length: ${FEEDBACK_MAX_LENGTH} characters`
              : ""
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="default" className="btn-success" onClick={_onSubmit}>
          Send Feedback
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

NegativeFeedbackModal.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

export { NegativeFeedbackModal };
